import { isPositiveNumber } from "et3-type-guards";
import ET3Div from "../../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../../../../core/et3-ui/ET3Margin";
import SenderIcon from "./SenderIcon";
import IsSeenTick from "./IsSeenTick";
import MessageBody from "./MessageBody";
import CreatedOn from "./MessageDate";
import { TGender } from "../../../../../../../Types";

const Message = withLiteObserverAndTheme<
  {
    isKhattabaMessage: boolean;
    isLastInSubGroup: boolean;
    isClientMessage: boolean;
    message: string;
    messageType: string;
    createdOn: string;
    isSeen: boolean;
    senderGender: TGender;
  } & { isLastInSubGroup: boolean }
>((props) => {
  const {
    theme,
    isKhattabaMessage,
    isLastInSubGroup,
    isClientMessage,
    message,
    createdOn,
    isSeen,
    messageType,
    senderGender
  } = props;
  const { colors, unitX } = theme;
  const backgroundColor = isKhattabaMessage
    ? colors.all.paleBluishGray
    : senderGender === "m"
      ? colors.all.bondiBlue
      : colors.all.vibrantPinkishMagenta;
  const isSeenMessage = isPositiveNumber(isSeen);

  return (
    <ET3Div
      width={1188}
      height={0}
      alignItems={"center"}
      fDirection={"row"}
      color={colors.all.transparent}
      justifyContent={isKhattabaMessage ? "flex-end" : "flex-start"}
      withShadow={false}
      isExtendable={true}
      isScrollable={false}
      onClick={() => {}}
      style={{}}
    >
      <Et3Margin left={10} right={5} top={0} bottom={0} />

      <SenderIcon
        isLastInSubGroup={isLastInSubGroup}
        isKhattabaMessage={isKhattabaMessage}
        isClientMessage={isClientMessage}
        senderGender={senderGender}
      />

      <Et3Margin left={0} right={10} top={0} bottom={0} />

      <ET3Div
        width={0}
        height={0}
        alignItems={"flex-end"}
        fDirection={"row"}
        color={""}
        justifyContent={"flex-start"}
        withShadow={false}
        isExtendable={true}
        isScrollable={false}
        onClick={() => {}}
        style={{
          backgroundColor,
          borderRadius: 20 * unitX,
          borderBottomRightRadius: isKhattabaMessage ? 0 : 20 * unitX,
          borderBottomLeftRadius: !isKhattabaMessage ? 0 : 20 * unitX,
          width: "auto",
          overflow: "hidden",
          maxWidth: 834 * unitX
        }}
      >
        <Et3Margin top={0} bottom={0} left={10} right={10} />

        <MessageBody
          message={message}
          messageType={messageType}
          isKhattabaMessage={isKhattabaMessage}
        />

        <Et3Margin top={0} bottom={0} left={10} right={10} />

        <IsSeenTick
          isSeenMessage={isSeenMessage}
          isKhattabaMessage={isKhattabaMessage}
        />

        <CreatedOn
          createdOn={createdOn}
          isKhattabaMessage={isKhattabaMessage}
        />

        <Et3Margin top={0} bottom={0} left={2} right={2} />
      </ET3Div>
      <Et3Margin left={20} right={20} top={0} bottom={0} />
    </ET3Div>
  );
});

export default Message;
